<div class="m-grid__item m-grid__item--fluid m-wrapper">
  <!-- BEGIN: Subheader -->
  <div class="m-subheader ">
    <div class="d-flex align-items-center">
      <div class="mr-auto">
        <h3 class="m-subheader__title m-subheader__title--separator">
          Licensing Calendar
        </h3>
      </div>
    </div>
  </div>
  <!-- END: Subheader -->
  <div class="m-content">
    <div class="row">
      <div class="col-lg-3">
        <!--begin::Portlet-->
        <div class="m-portlet" id="m_portlet">
          <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
              <div class="m-portlet__head-title">
                <span class="m-portlet__head-icon">
                  <i class="flaticon-add"></i>
                </span>
                <h3 class="m-portlet__head-text">
                  Drag Song to Date
                </h3>
              </div>
            </div>
          </div>
          <div class="m-portlet__body">
            <div id="m_calendar_external_events" class="fc-unthemed">
              <div class='fc-event fc-event-external fc-start m-fc-event--primary m--margin-bottom-15' data-color="m-fc-event--primary">
                <div class="fc-title">
                  <div class="fc-content">
                    Song number 1
                  </div>
                </div>
              </div>
              <div class='fc-event fc-event-external fc-start m-fc-event--accent  m--margin-bottom-15' data-color="m-fc-event--accent">
                <div class="fc-title">
                  <div class="fc-content">
                    Song number 2
                  </div>
                </div>
              </div>
              <div class='fc-event fc-event-external fc-start m-fc-event--focus  m--margin-bottom-15' data-color="m-fc-event--focus">
                <div class="fc-title">
                  <div class="fc-content">
                    Song number 3
                  </div>
                </div>
              </div>
              <div class='fc-event fc-event-external fc-start m-fc-event--warning  m--margin-bottom-15' data-color="m-fc-event--warning">
                <div class="fc-title">
                  <div class="fc-content">
                    Song number 4
                  </div>
                </div>
              </div>

              <div class="m-separator m-separator--dashed m-separator--space"></div>
              <div>
                <label class="m-checkbox m-checkbox--brand">
                  <input type="checkbox" id='m_calendar_external_events_remove'>
                  Remove after drop
                  <span></span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <!--end::Portlet-->
      </div>
      <div class="col-lg-9">
        <!--begin::Portlet-->
        <div class="m-portlet" id="m_portlet">
          <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
              <div class="m-portlet__head-title">
                <span class="m-portlet__head-icon">
                  <i class="flaticon-calendar-2"></i>
                </span>
                <h3 class="m-portlet__head-text">
                  Licensing Calender
                </h3>
              </div>
            </div>

          </div>
          <div class="m-portlet__body">
            <div id="m_calendar"></div>
          </div>
        </div>
        <!--end::Portlet-->
      </div>
    </div>
  </div>
</div>
